import * as Actions    from './actions';
import * as Selectors  from './selectors';
import { compose }     from 'redux';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import ms              from 'ms';


export const scheduledCampaignDelay = ms('30m');

// Campaign Hooks

// Selectors

export function useCampaigns(businessID) {
  return useSelector(state => Selectors.getCampaigns(state, businessID));
}

export function useCampaignsStatuses(businessID) {
  return useSelector(state => Selectors.getCampaignsStatuses(state, businessID));
}

export function useCampaign(campaignID) {
  return useSelector(state => Selectors.getCampaign(state, campaignID));
}


// Actions

export function useCreateCampaign(businessID) {
  return compose(useDispatch(), Actions.createCampaign, campaign => ({ businessID, campaign }));
}

export function useUpdateCampaign(businessID) {
  return compose(useDispatch(), Actions.updateCampaign, campaign => ({ businessID, campaign }));
}

export function useDeleteCampaign(businessID) {
  return compose(useDispatch(), Actions.deleteCampaign, campaign => ({ businessID, campaign }));
}


export function useSaveCampaign(businessID) {
  const createCampaign = useCreateCampaign(businessID);
  const updateCampaign = useUpdateCampaign(businessID);
  return async function saveCampaign(campaign) {
    if (campaign.id)
      return await updateCampaign(campaign);
    else
      return await createCampaign(campaign);
  };
}


export function useScheduleCampaign(businessID) {
  const saveCampaign = useSaveCampaign(businessID);
  return async function scheduleCampaign(campaign) {
    const status             = 'scheduled';
    const scheduledTimestamp = Date.now() + scheduledCampaignDelay;
    const scheduledAt        = new Date(scheduledTimestamp).toISOString();

    const scheduledCampaign = {
      ...campaign,
      status,
      scheduledAt
    };

    return await saveCampaign(scheduledCampaign);
  };
}


export function useConvertCampaignToDraft(businessID) {
  const saveCampaign = useSaveCampaign(businessID);
  return async function convertCampaignToDraft(campaign) {
    const status      = 'draft';
    const scheduledAt = null;

    const draftCampaign = {
      ...campaign,
      status,
      scheduledAt
    };

    return await saveCampaign(draftCampaign);
  };
}
